<template>
  <section class="c-searchbar">
    <div class="c-searchbar__search">
      <input
        class        = "c-searchbar__search__query-input"
        type         = "text"
        name         = "rewards_query_input"
        @keyup.enter = "queryRewards"
        v-model      = "query"
        :placeholder  = "$t('web.catalog_search_bar.search_placeholder')"
        @focus       = "toggleQueryInputFocused"
        @blur        = "toggleQueryInputFocused"
      />

      <ol v-show="showContextsDropdown" class="c-searchbar__search__dropdown">
        <li
          v-for  = "context in contexts"
          v-html = "query + ' <i>' + context.label + '</i>'"
          @click = "queryRewards($event, context.otherParams)"
        ></li>
      </ol>

      <button
        @click = "queryRewards"
        class  = "c-searchbar__search__button t-button-plain-color"
      >
        <i class="fa fa-search"></i>
      </button>
    </div>

    <router-link
      :to="{ name: 'SavedRewards' }"
      class="c-searchbar__saved-for-later"
      :class="[ isSavedRewardsPage ? 'u-disable-hover-cursor t-button-primary' : 't-button-plain-color' ]"
    >
      <i class="fa fa-heart"></i>
    </router-link>
  </section>
</template>




<script>
  import { find, get, merge } from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SearchBar',

    data () {
      return {
        queryInputFocused: false,
        query: this.$route.query.search
      }
    },

    computed: {
      ...mapGetters([
        'participant'
      ]),

      /**
       * Get the category applied to rewards.
       *
       * @return {object}
       */
      appliedCategoryName () {
        return get(find(
          get(this.$store.getters, 'categories', []),
          category => category.code === this.$route.query.category
        ), 'name.' + this.participant.catalog_locale)
      },

      /**
       * Contexts available to search within.
       *
       * @return {array}
       */
      contexts () {
        return this.$route.query.category
          ? [{
            label: this.$t('web.catalog_search_bar.search_all_categories')
          },
          {
            label: this.$t('web.catalog_search_bar.search_current_category', {current_category: this.appliedCategoryName}),
            otherParams: { category: this.$route.query.category }
          }]
          : []
      },

      isSavedRewardsPage () {
        return this.$route.name === 'SavedRewards'
      },

      /**
       * Determine whether to show the contexts dropdown.
       *
       * @return {boolean}
       */
      showContextsDropdown () {
        return this.contexts.length && this.query && this.queryInputFocused
      }
    },

    methods: {
      /**
       * Toggle the state query input's focused state.
       *
       * @return {void}
       */
      toggleQueryInputFocused () {
        // Without setting a timeout, clicking on a context doesn't work because
        // the blur event triggers before the click.
        setTimeout(() => {
          this.queryInputFocused = !this.queryInputFocused
        }, 100)
      },

      /**
       * Perform a rewards search via the API.
       *
       * @param {object} $event Event that triggered this call. Required because
       *                        Vue passes it when no arguments passed.
       * @param {object} otherParams Query parameters to merge with search query.
       * @return {void}
       */
      queryRewards ($event, otherParams) {
        const query = this.query ? { search: this.query } : {}

        this.$router.push({
          name: 'Rewards Results',
          query: typeof otherParams === 'object' ? merge(query, otherParams) : query
        })
      }
    }
}
</script>



// WEBPACK FOOTER //
// SearchBar.vue?2c2a29a2